import {
  SecurityLayout
} from 'src/pages'
import i18n from '../../i18n'

const pageByMode = (mode = 'signin') => {
  switch (mode) {
    case 'signup':
      return '/security/signup'
    case 'signin':
    default:
      return '/security/signin'
  }
}

export default ({ store }) => [
  {
    path: '/auth',
    component: SecurityLayout,
    children: [
      {
        path: '',
        meta: { requiresNoAuth: true },
        async beforeEnter (to, from, next) {
          const { redirect_uri: redirectUrl, state, mode, refcode, code_challenge: codeChallenge, ...otherParams } = to.query
          const clientId = otherParams.clientId || otherParams.client_id

          // set language
          let language = 'en'

          if (otherParams.language) {
            language = otherParams.language.toLowerCase()
          }

          i18n.locale = language
          await store.dispatch('language/selectLanguage', otherParams.language)

          // workaround. Signout on oauth login
          await store.dispatch('passport/signout')

          // check strategy
          const client = await store.dispatch('passport/fetchClient', { clientId })

          if (!client || !client.redirectUrls.includes(redirectUrl)) {
            // TODO: handle not found error. pass errorcode and create page
            next('/auth/error')
            return
          }

        await store.dispatch('passport/saveContext', { client, redirectUrl, state, refcode, codeChallenge })

          const path = (store.state.passport.user != null)
            ? '/security/grant'
            : pageByMode(mode)

          next({
            path
          })
        }
      }
    ]
  }
]
